const isLocal = window.location.hostname === 'localhost' || 
                window.location.hostname === '127.0.0.1' || 
                window.location.hostname.startsWith('192.168.');

export const environment = {
  production: false,
  apiUrl: isLocal ? `http://${window.location.hostname}:8082/api/v1.0` : 'https://weddingly.lambdadigital.co.in/api/v1.0'
};
